// src/components/dropdown/dropdown.custom.styles.ts
import { css } from "lit";
var dropdown_custom_styles_default = css`
  /* Write custom CSS here */
`;
export { dropdown_custom_styles_default };
